import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex bg-black gap-3 pr-3" }

import Logo from "@/components/identity/Logo.vue";
import Triangle from "@/components/identity/Triangle.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'BrandBar',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Triangle),
      _createVNode(Logo, { size: 40 })
    ]),
    _createVNode(Triangle, { color: "black" })
  ]))
}
}

})